export default {
  namespaced: true,
  state: {
    messagesList: []
  },
  getters: {},
  mutations: {
   clearMessages(state) {
     state.messagesList = []
   },
    addError(state, payload) {
     state.messagesList.push({type: 'error', msg: payload})
    },
    addWarning(state, payload) {
      state.messagesList.push({type: 'warning', msg: payload})
    },
    addSuccess(state, payload) {
      state.messagesList.push({type: 'success', msg: payload})
    }
  },
}
